export const calculateShowComponents = (
  showArray: Array<boolean | undefined>,
  hideArray: Array<boolean | undefined>,
) => {
  if (showArray.length !== hideArray.length) {
    throw new Error('show and hide must have the same length')
  }
  if (showArray.some(Boolean) && hideArray.some(Boolean)) {
    throw new Error(
      'show and hide must not have any true values at the same time',
    )
  }

  const result = []
  for (let i = 0; i < showArray.length; i++) {
    if (showArray.some(Boolean)) {
      result.push(showArray[i])
    } else {
      result.push(!hideArray[i])
    }
  }
  return result
}
